<template>
  <div class="page-background">
    <!-- ===================== HERO PRINCIPAL ===================== -->
    <header class="kl-home-hero">
      <div class="kl-home-hero__decor" aria-hidden="true"></div>
      <div class="kl-home-hero__inner">
        <div class="kl-home-hero__text">
          <span class="kl-home-hero__eyebrow">KeyLearning</span>
          <h1 class="kl-home-hero__title">
            {{ $t("home.homeView.solutionTitle") }}
          </h1>
          <ul class="kl-home-hero__list">
            <li>
              <b-icon icon="check-circle-fill"></b-icon>
              <span class="text-left">{{
                $t("home.homeView.solutionFeature1")
              }}</span>
            </li>
            <li>
              <b-icon icon="check-circle-fill"></b-icon>
              <span class="text-left">{{
                $t("home.homeView.solutionFeature2")
              }}</span>
            </li>
            <li>
              <b-icon icon="check-circle-fill"></b-icon>
              <span class="text-left">{{
                $t("home.homeView.solutionFeature3")
              }}</span>
            </li>
            <li>
              <b-icon icon="check-circle-fill"></b-icon>
              <span class="text-left">{{
                $t("home.homeView.solutionFeature4")
              }}</span>
            </li>
            <li>
              <b-icon icon="check-circle-fill"></b-icon>
              <span class="text-left">{{
                $t("home.homeView.carousel1Slide4Title")
              }}</span>
            </li>
          </ul>
          <b-button
            variant="none"
            class="kl-home-hero__cta"
            @click="scrollToDiv('contact-us')"
          >
            {{ $t("home.homeView.contactUs") }}
          </b-button>
        </div>
        <div class="kl-home-hero__media">
          <div class="kl-hero-visual">
            <span
              class="kl-hero-visual__blob kl-hero-visual__blob--1"
              aria-hidden="true"
            ></span>
            <span
              class="kl-hero-visual__blob kl-hero-visual__blob--2"
              aria-hidden="true"
            ></span>

            <!-- Captura real: repositorio de planes de estudio -->
            <figure class="kl-hero-shot">
              <div class="kl-hero-shot__bar" aria-hidden="true">
                <span class="kl-hero-shot__dot"></span>
                <span class="kl-hero-shot__dot"></span>
                <span class="kl-hero-shot__dot"></span>
              </div>
              <img
                class="kl-hero-shot__img"
                src="@/assets/new-page/repositorio_plan_estudio.png"
                :alt="$t('home.homeView.heroShotAlt')"
              />
              <figcaption class="kl-hero-shot__caption">
                <b-icon
                  icon="collection-fill"
                  class="kl-hero-shot__caption-icon"
                ></b-icon>
                {{ $t("home.homeView.heroShotCaption") }}
              </figcaption>
            </figure>
          </div>
        </div>
      </div>
    </header>
    <div
      class=""
      style="display: flex; flex-direction: column; flex-wrap: nowrap"
    >
      <div class="diagram-section">
        <!-- Diagrama central: KL Innovation + KL Assessment -->
        <div class="kl-diagram mb-5">
          <div class="kl-diagram__panel kl-diagram__panel--innovation">
            <span class="kl-diagram__tag">KL</span>
            <span class="kl-diagram__name">INNOVATION</span>
          </div>
          <div class="kl-diagram__panel kl-diagram__panel--assessment">
            <span class="kl-diagram__tag">KL</span>
            <span class="kl-diagram__name">ASSESSMENT</span>
          </div>
          <div class="kl-diagram__hub" aria-hidden="true">
            <img src="../../assets/logo_klearning.png" alt="KeyLearning" />
          </div>
        </div>
        <!-- ============ VISTAZO A LA PLATAFORMA (screenshots) ============ -->
        <section class="kl-shots">
          <div class="kl-shots__shell">
            <h2 class="kl-block-title">
              {{ $t("home.homeView.screenshotsTitle") }}
            </h2>
            <span class="kl-block-accent"></span>
            <p class="kl-shots__subtitle">
              {{ $t("home.homeView.screenshotsSubtitle") }}
            </p>

            <b-carousel
              id="screenshots-carousel"
              v-model="screenshotPage"
              class="kl-shots__carousel"
              :interval="10000"
              controls
              indicators
              background="transparent"
            >
              <b-carousel-slide
                v-for="(shot, index) in screenshots"
                :key="'shot-' + index"
              >
                <template #img>
                  <figure class="kl-shot">
                    <div class="kl-shot__frame">
                      <div class="kl-shot__bar" aria-hidden="true">
                        <span class="kl-shot__dot"></span>
                        <span class="kl-shot__dot"></span>
                        <span class="kl-shot__dot"></span>
                      </div>
                      <img
                        class="kl-shot__img"
                        :src="shot.img"
                        :alt="$t('home.homeView.' + shot.caption)"
                      />
                      <figcaption class="kl-shot__caption">
                        <b-icon
                          icon="eye-fill"
                          class="kl-shot__caption-icon"
                        ></b-icon>
                        {{ $t("home.homeView." + shot.caption) }}
                      </figcaption>
                    </div>
                  </figure>
                </template>
              </b-carousel-slide>
            </b-carousel>
          </div>
        </section>
      </div>
    </div>
    <Brochure></Brochure>

    <!-- ===================== FUNCIONALIDADES ===================== -->
    <section class="kl-features">
      <div class="kl-features__shell">
        <h2 class="kl-block-title">{{ $t("home.homeView.carousel2Title") }}</h2>
        <span class="kl-block-accent"></span>
        <div class="kl-features__grid">
          <div
            v-for="(feature, index) in features"
            :key="'feature-' + index"
            class="kl-feature-card"
          >
            <div class="kl-feature-card__icon">
              <span
                class="kl-feature-card__glyph"
                :style="{
                  '-webkit-mask-image': 'url(' + feature.icon + ')',
                  'mask-image': 'url(' + feature.icon + ')',
                }"
              ></span>
            </div>
            <p class="kl-feature-card__text">
              {{ $t("home.homeView." + feature.text) }}
            </p>
          </div>
        </div>
      </div>
    </section>

    <!-- ===================== DESCARGA DE DOCUMENTOS ===================== -->
    <section class="kl-docs">
      <div class="kl-docs__shell">
        <h2 class="kl-block-title">
          {{ $t("home.homeView.pdfSectionTitle") }}
        </h2>
        <span class="kl-block-accent"></span>
        <div class="kl-docs__grid">
          <article class="kl-doc-card">
            <div class="kl-doc-card__top">
              <span class="kl-doc-card__badge">PDF</span>
              <h3 class="kl-doc-card__title">
                {{ $t("home.homeView.pdfCard1Title") }}
              </h3>
            </div>
            <p class="kl-doc-card__desc">
              {{ $t("home.homeView.pdfCard1Description") }}
            </p>
            <b-button
              variant="none"
              class="kl-doc-card__btn"
              @click="downloadPDFCompetenceMonitoring()"
            >
              <span>{{ $t("home.homeView.download") }}</span>
            </b-button>
          </article>

          <article class="kl-doc-card">
            <div class="kl-doc-card__top">
              <span class="kl-doc-card__badge">PDF</span>
              <h3 class="kl-doc-card__title">
                {{ $t("home.homeView.pdfCard2Title") }}
              </h3>
            </div>
            <p class="kl-doc-card__desc">
              {{ $t("home.homeView.pdfCard2Description") }}
            </p>
            <b-button
              variant="none"
              class="kl-doc-card__btn"
              @click="downloadPDFCompetenceApproach()"
            >
              <span>{{ $t("home.homeView.download") }}</span>
            </b-button>
          </article>
        </div>
      </div>
    </section>
    <!-- ===================== BENEFICIOS ===================== -->
    <section class="kl-benefits">
      <div class="kl-benefits__shell">
        <h2 class="kl-block-title kl-block-title--light">
          {{ $t("home.homeView.carousel3Title") }}
        </h2>
        <span class="kl-block-accent kl-block-accent--light"></span>

        <b-carousel
          id="benefits-carousel"
          v-model="benefitPage"
          class="kl-benefits__carousel"
          :interval="10000"
          controls
          indicators
          background="transparent"
        >
          <b-carousel-slide
            v-for="(page, pageIndex) in benefitPages"
            :key="'benefit-page-' + pageIndex"
          >
            <template #img>
              <div class="kl-benefits__page">
                <div
                  v-for="(benefit, index) in page"
                  :key="'benefit-' + pageIndex + '-' + index"
                  class="kl-benefit-card"
                >
                  <div class="kl-benefit-card__icon">
                    <img :src="benefit.icon" alt="" />
                  </div>
                  <h3 class="kl-benefit-card__title">
                    {{ $t("home.homeView." + benefit.title) }}
                  </h3>
                  <p class="kl-benefit-card__desc">
                    {{ $t("home.homeView." + benefit.desc) }}
                  </p>
                </div>
              </div>
            </template>
          </b-carousel-slide>
        </b-carousel>
      </div>
    </section>
    <!-- Seccion IA -->
    <div class="ia-section-container">
      <div class="ia-content">
        <div class="ia-header">
          <div class="ia-icon-wrapper">
            <img src="@/assets/icon-ai.svg" alt="AI Icon" class="ia-icon" />
          </div>
          <div class="ia-header-text">
            <h2 class="ia-title">{{ $t("home.homeView.iaTitle") }}</h2>
            <div class="ia-subtitle">
              {{ $t("home.homeView.iaSubtitle") }}
            </div>
          </div>
        </div>

        <div class="ia-body">
          <p class="ia-paragraph">
            {{
              $t("home.homeView.iaParagraph1", {
                entity: "KeyLearning",
              })
            }}
          </p>
          <p class="ia-paragraph ia-highlight">
            {{
              $t("home.homeView.iaParagraph2", {
                entity: "KeyLearning",
              })
            }}
          </p>
        </div>

        <div class="ia-footer-section">
          <div class="ia-footer-badge">
            <span class="ia-badge-icon">✦</span>
            <span class="ia-footer-title">{{
              $t("home.homeView.iaFooterTitle", {
                entity: "KeyLearning SPA.",
              })
            }}</span>
          </div>
          <p class="ia-footer-text">
            {{
              $t("home.homeView.iaFooterText", {
                entity: "KeyLearning",
              })
            }}
          </p>
        </div>
      </div>
    </div>

    <ContactForm :id="'contact-us'"></ContactForm>
    <div class="home-map-wrapper">
      <div class="home-map">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3330.709467129193!2d-70.5702077!3d-33.40474319999999!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x9662ced93c8100f7%3A0x1af432465bddb03d!2sCerro%20El%20Plomo%205931%2C%207561160%20Las%20Condes%2C%20Regi%C3%B3n%20Metropolitana!5e0!3m2!1ses!2scl!4v1714157056208!5m2!1ses!2scl"
          width="100%"
          height="100%"
          frameborder="0"
          style="border: 0"
          allowfullscreen=""
          aria-hidden="false"
          tabindex="0"
          title="Mapa de ubicación KeyLearning"
        ></iframe>
      </div>
    </div>
    <ContactBanner></ContactBanner>
  </div>
</template>

<script>
import { brochureUrl } from "@/utils/globals";

export default {
  name: "Home",
  components: {
    Brochure: () => import("@/components/new-page/Brochure"),
    ContactForm: () => import("@/components/new-page/ContactForm"),
    ContactBanner: () => import("@/components/new-page/ContactBanner"),
    // RenderVHtml: () => import("@/components/reusable/RenderVHtml"),
  },
  props: {},
  data() {
    return {
      features: [
        {
          icon: require("../../assets/new-page/Carousel-funcionalidades-icono-01.svg"),
          text: "carousel2Card1",
        },
        {
          icon: require("../../assets/new-page/Carousel-funcionalidades-icono-02.svg"),
          text: "carousel2Card2",
        },
        {
          icon: require("../../assets/new-page/Carousel-funcionalidades-icono-03.svg"),
          text: "carousel2Card3",
        },
        {
          icon: require("../../assets/new-page/Carousel-funcionalidades-icono-04.svg"),
          text: "carousel2Card4",
        },
        {
          icon: require("../../assets/new-page/Carousel-funcionalidades-icono-05.svg"),
          text: "carousel2Card5",
        },
        {
          icon: require("../../assets/new-page/Carousel-funcionalidades-icono-06.svg"),
          text: "carousel2Card6",
        },
      ],
      benefits: [
        {
          icon: require("../../assets/new-page/Carousel-Beneficios-icono-01.svg"),
          title: "carousel3Card1Title",
          desc: "carousel3Card1Description",
        },
        {
          icon: require("../../assets/new-page/Carousel-Beneficios-icono-02.svg"),
          title: "carousel3Card2Title",
          desc: "carousel3Card2Description",
        },
        {
          icon: require("../../assets/new-page/carousel-1-logo-1.svg"),
          title: "carousel3Card3Title",
          desc: "carousel3Card3Description",
        },
        {
          icon: require("../../assets/new-page/Carousel-Beneficios-icono-04.svg"),
          title: "carousel3Card4Title",
          desc: "carousel3Card4Description",
        },
        {
          icon: require("../../assets/new-page/Carousel-Beneficios-icono-05.svg"),
          title: "carousel3Card5Title",
          desc: "carousel3Card5Description",
        },
        {
          icon: require("../../assets/new-page/Carousel-Beneficios-icono-06.svg"),
          title: "carousel3Card6Title",
          desc: "carousel3Card6Description",
        },
        {
          icon: require("../../assets/new-page/Carousel-Beneficios-icono-07.svg"),
          title: "carousel3Card7Title",
          desc: "carousel3Card7Description",
        },
        {
          icon: require("../../assets/new-page/Carousel-Beneficios-icono-08.svg"),
          title: "carousel3Card8Title",
          desc: "carousel3Card8Description",
        },
        {
          icon: require("../../assets/new-page/Carousel-Beneficios-icono-09.svg"),
          title: "carousel3Card9Title",
          desc: "carousel3Card9Description",
        },
        {
          icon: require("../../assets/new-page/Carousel-Beneficios-icono-10.svg"),
          title: "carousel3Card10Title",
          desc: "carousel3Card10Description",
        },
      ],
      benefitPage: 0,
      // Carousel de vistazo a la plataforma (capturas reales en assets/new-page).
      screenshotPage: 0,
      screenshots: [
        {
          img: require("../../assets/new-page/dashboard_estudiante.png"),
          caption: "screenshotDashboardStudent",
        },
        {
          img: require("../../assets/new-page/dashboard_profesor.png"),
          caption: "screenshotDashboardTeacher",
        },
        {
          img: require("../../assets/new-page/dashboard_administrativo.png"),
          caption: "screenshotDashboardAdmin",
        },
        {
          img: require("../../assets/new-page/malla_curricular.png"),
          caption: "screenshotCurricularMesh",
        },
        {
          img: require("../../assets/new-page/plan_de_estudio.png"),
          caption: "screenshotStudyPlan",
        },
        {
          img: require("../../assets/new-page/programa_asignatura.png"),
          caption: "screenshotMatterProgram",
        },
        {
          img: require("../../assets/new-page/matriz_3.png"),
          caption: "screenshotMatrix3",
        },
        {
          img: require("../../assets/new-page/evaluacion_kl.png"),
          caption: "screenshotEvaluation",
        },
        {
          img: require("../../assets/new-page/generacion_con_ia.png"),
          caption: "screenshotAiGeneration",
        },
        {
          img: require("../../assets/new-page/reporte_kl.png"),
          caption: "screenshotReport",
        },
      ],
    };
  },
  computed: {
    benefitPages() {
      const pageSize = 2;
      const pages = [];
      for (let i = 0; i < this.benefits.length; i += pageSize) {
        pages.push(this.benefits.slice(i, i + pageSize));
      }
      return pages;
    },
  },
  methods: {
    scrollToDiv(div_id) {
      window.scrollTo({ top: 0 });
      const div = document.getElementById(div_id);
      if (div) {
        const offset = 100; // Número de píxeles para desplazar hacia arriba
        const divPosition = div.getBoundingClientRect().top;
        const offsetPosition = divPosition - offset;
        window.scrollTo({
          top: offsetPosition,
          behavior: "smooth",
        });
      }
    },
    downloadPDFCompetenceMonitoring() {
      const language = this.$i18n.locale || "es";
      const url = brochureUrl(language == "en" ? "Technological Management Model.pdf" : "Modelo Tecnológico de Gestión.pdf");
      window.open(url, "_blank");
    },
    downloadPDFCompetenceApproach() {
      const language = this.$i18n.locale || "es";
      const url = brochureUrl(language == "en" ? "Fundamentals of the Competency-Based Approach.pdf" : "Fundamento del Enfoque por Competencias.pdf");
      window.open(url, "_blank");
    },
  },
  mounted() {},
  created() {},
};
</script>

<style scoped>
.container-saas {
  display: flex;
  justify-self: center;
  width: 50%;
}
.font-header-saas {
  font-family: "Source Sans Pro", sans-serif;
  font-style: normal;
  font-weight: 700;
  font-size: 36px;
  line-height: 150%;
  text-align: center;
  letter-spacing: -0.022em;
  text-transform: uppercase;
  color: #f5f5f5;
}
.font-description-saas {
  font-family: "Source Sans Pro", sans-serif;
  font-style: normal;
  font-size: 16px;
  line-height: 150%;
  text-align: center;
  padding: 0 30px;
  color: #f5f5f5;
}
.borchure-saas {
  height: auto;
  border-radius: 20px;
  color: white;
  padding: 40px;
}
.brochure-left-saas {
  /* background: #006ec8; */
  background: url(../../assets/new-page/Carousel-funcionalidades-fondo-04.svg)
    no-repeat center;
  background-size: cover;
  -moz-background-size: cover;
  -webkit-background-size: cover;
  -o-background-size: cover;
}
.borchure {
  height: auto;
  background: #006ec8;
  border-radius: 10px;
  color: white;
  padding: 40px;
}
.brochure-left {
  /* background: #006ec8; */
  background: url(../../assets/new-page/Mision-recuadro.svg) no-repeat center
    center;
  background-size: cover;
  -moz-background-size: cover;
  -webkit-background-size: cover;
  -o-background-size: cover;
}
.page-background {
  /* Migrado al sistema global de tokens (utils/styles_kl.css). */
  --kl-blue: var(--kl-color-primary);
  --kl-blue-dark: var(--kl-color-primary-deep);
  --kl-teal: var(--kl-color-secondary);
  --kl-ink: var(--kl-text-heading);
  --kl-text: var(--kl-text-body);
  --kl-bg: var(--kl-bg-page);
  --kl-card: var(--kl-surface);
  --kl-border: var(--kl-border-soft);
  --kl-shadow: var(--kl-shadow-lg);
  --kl-shadow-hover: var(--kl-shadow-lg-hover);

  background: var(--kl-bg);
}

/* ===================== HERO PRINCIPAL ===================== */
.kl-home-hero {
  position: relative;
  background: linear-gradient(
    130deg,
    var(--kl-blue-dark) 0%,
    var(--kl-blue) 55%,
    var(--kl-teal) 120%
  );
  color: #ffffff;
  padding: 70px 32px 90px;
  border-bottom-right-radius: 60px;
  overflow: hidden;
}
.kl-home-hero__decor {
  position: absolute;
  top: -140px;
  right: -100px;
  width: 520px;
  height: 520px;
  border-radius: 50%;
  background: radial-gradient(
    circle at center,
    rgba(255, 255, 255, 0.16) 0%,
    rgba(255, 255, 255, 0) 70%
  );
  pointer-events: none;
}
.kl-home-hero__inner {
  position: relative;
  z-index: 1;
  max-width: 1400px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1.05fr 0.95fr;
  align-items: center;
}
.kl-home-hero__eyebrow {
  display: inline-block;
  font-size: var(--kl-fs-small);
  font-weight: var(--kl-fw-bold);
  letter-spacing: var(--kl-ls-wider);
  text-transform: uppercase;
  color: rgba(255, 255, 255, 0.85);
  padding: 7px 16px;
  border: 1px solid rgba(255, 255, 255, 0.35);
  border-radius: var(--kl-radius-pill);
  margin-bottom: 22px;
}
.kl-home-hero__title {
  font-weight: var(--kl-fw-bold);
  font-size: var(--kl-fs-hero);
  line-height: var(--kl-lh-tight);
  margin: 0 0 28px;
  letter-spacing: var(--kl-ls-tight);
  text-transform: uppercase;
}
.kl-home-hero__list {
  list-style: none;
  padding: 0;
  margin: 0 0 34px;
  display: flex;
  flex-direction: column;
  gap: 14px;
}
.kl-home-hero__list li {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  font-size: var(--kl-fs-body-lg);
  font-weight: var(--kl-fw-semibold);
  line-height: 1.4;
  color: rgba(255, 255, 255, 0.95);
}
.kl-home-hero__list .b-icon {
  flex-shrink: 0;
  font-size: 20px;
  margin-top: 2px;
  color: #ffffff;
}
.kl-home-hero__cta {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 56px;
  padding: 0 38px;
  border: none;
  border-radius: var(--kl-radius-pill);
  background: #ffffff;
  color: var(--kl-blue-dark);
  font-weight: var(--kl-fw-bold);
  font-size: var(--kl-fs-small);
  letter-spacing: 0.1em;
  text-transform: uppercase;
  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.18);
  transition: transform 0.25s ease, box-shadow 0.25s ease;
}
.kl-home-hero__cta:hover {
  color: var(--kl-blue-dark);
  transform: translateY(-2px);
  box-shadow: 0 16px 38px rgba(0, 0, 0, 0.25);
}
.kl-home-hero__media {
  display: flex;
  justify-content: center;
}

/* ---- Composición visual del hero (reemplaza el banner img) ---- */
.kl-hero-visual {
  position: relative;
  width: 100%;
  max-width: 550px;
}
.kl-hero-visual__blob {
  position: absolute;
  border-radius: 50%;
  z-index: 0;
  pointer-events: none;
  filter: blur(2px);
}
.kl-hero-visual__blob--1 {
  width: 130px;
  height: 130px;
  top: -30px;
  left: -36px;
  background: radial-gradient(
    circle at 30% 30%,
    rgba(255, 255, 255, 0.45),
    rgba(255, 255, 255, 0)
  );
}
.kl-hero-visual__blob--2 {
  width: 170px;
  height: 170px;
  bottom: -44px;
  right: -32px;
  background: radial-gradient(
    circle at 70% 70%,
    rgba(1, 173, 183, 0.6),
    rgba(1, 173, 183, 0)
  );
}

/* Captura real dentro de un marco tipo "ventana de app" */
.kl-hero-shot {
  position: relative;
  z-index: 1;
  margin: 0;
  background: #ffffff;
  border-radius: 20px;
  overflow: hidden;
}
.kl-hero-shot__bar {
  display: flex;
  align-items: center;
  gap: 7px;
  padding: 12px 16px;
  background: linear-gradient(
    90deg,
    rgba(0, 110, 200, 0.06),
    rgba(1, 173, 183, 0.06)
  );
  border-bottom: 1px solid var(--kl-border);
}
.kl-hero-shot__dot {
  width: 11px;
  height: 11px;
  border-radius: 50%;
  background: rgba(16, 38, 73, 0.18);
}
.kl-hero-shot__dot:nth-child(1) {
  background: var(--kl-blue);
}
.kl-hero-shot__dot:nth-child(2) {
  background: var(--kl-teal);
}
.kl-hero-shot__img {
  display: block;
  width: 100%;
  height: auto;
}
.kl-hero-shot__caption {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 16px;
  border-top: 1px solid var(--kl-border);
  font-size: var(--kl-fs-caption);
  font-weight: var(--kl-fw-semibold);
  color: var(--kl-text-muted);
  justify-content: center;
}
.kl-hero-shot__caption-icon {
  color: var(--kl-color-primary);
}

.kl-hero-stage {
  position: relative;
  z-index: 1;
  background: #ffffff;
  border-radius: 26px;
  padding: 26px 26px 30px;
  box-shadow: 0 30px 70px rgba(0, 0, 0, 0.3);
}

/* Ventana tipo app */
.kl-hero-stage__window {
  display: flex;
  align-items: center;
  gap: 7px;
  padding-bottom: 18px;
  margin-bottom: 20px;
  border-bottom: 1px solid var(--kl-border);
}
.kl-hero-stage__dot {
  width: 11px;
  height: 11px;
  border-radius: 50%;
  background: rgba(16, 38, 73, 0.18);
}
.kl-hero-stage__dot:nth-child(1) {
  background: var(--kl-blue);
}
.kl-hero-stage__dot:nth-child(2) {
  background: var(--kl-teal);
}
.kl-hero-stage__addr {
  flex: 1;
  height: 18px;
  margin-left: 10px;
  border-radius: 999px;
  background: linear-gradient(
    90deg,
    rgba(0, 110, 200, 0.1),
    rgba(1, 173, 183, 0.1)
  );
}

/* Título sobre las barras */
.kl-hero-stage__caption {
  display: flex;
  flex-direction: column;
  line-height: 1.2;
}
.kl-hero-stage__caption span:first-child {
  font-weight: var(--kl-fw-bold);
  font-size: var(--kl-fs-title-sm);
  color: var(--kl-ink);
}
.kl-hero-stage__caption span:last-child {
  font-weight: var(--kl-fw-bold);
  font-size: var(--kl-fs-body);
  background: linear-gradient(90deg, var(--kl-blue), var(--kl-teal));
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

/* Barras de acento */
.kl-hero-stage__bars {
  margin-top: 22px;
  display: flex;
  align-items: flex-end;
  gap: 10px;
  height: 76px;
  padding: 0 4px;
}
.kl-hero-stage__bars span {
  flex: 1;
  border-radius: 8px 8px 4px 4px;
  background: linear-gradient(180deg, var(--kl-teal) 0%, var(--kl-blue) 100%);
  opacity: 0.92;
}

/* Tiles con iconos */
.kl-hero-stage__tiles {
  margin-top: 20px;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
}
.kl-hero-tile {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  padding: 14px 8px;
  border-radius: 14px;
  background: linear-gradient(
    135deg,
    rgba(0, 110, 200, 0.08),
    rgba(1, 173, 183, 0.08)
  );
  border: 1px solid var(--kl-border);
}
.kl-hero-tile__icon {
  width: 38px;
  height: 38px;
  border-radius: 11px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, var(--kl-blue), var(--kl-teal));
  color: #ffffff;
  font-size: 18px;
}
.kl-hero-tile__title {
  font-weight: var(--kl-fw-bold);
  font-size: var(--kl-fs-small);
  line-height: 1.2;
  color: var(--kl-ink);
  text-align: center;
}
.kl-hero-tile__desc {
  font-size: var(--kl-fs-caption);
  line-height: 1.35;
  color: var(--kl-text);
  text-align: center;
}
@media (max-width: 900px) {
  .kl-home-hero {
    padding: 56px 22px 70px;
    border-bottom-right-radius: 40px;
  }
  .kl-home-hero__inner {
    grid-template-columns: 1fr;
    gap: 36px;
    text-align: center;
  }
  .kl-home-hero__list {
    display: inline-flex;
    text-align: left;
  }
  .kl-home-hero__media {
    display: none;
  }
}
.user-button:hover {
  color: white;
  transform: translateY(-2px);
  filter: brightness(1.05);
  box-shadow: 0 14px 30px rgba(0, 110, 200, 0.35);
}
.user-button {
  background: linear-gradient(135deg, #006ec8 0%, #01adb7 100%);
  border: none;
  width: 14em;
  height: 3.6em;
  color: white;
  border-radius: 55px;
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 17px;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  box-shadow: 0 10px 24px rgba(0, 110, 200, 0.28);
  transition: transform 0.25s ease, box-shadow 0.25s ease, filter 0.25s ease;
}
/* ============================================================
   Bloques de grilla (Funcionalidades / Beneficios)
   ============================================================ */
.kl-block-title {
  text-align: center;
  font-weight: var(--kl-fw-bold);
  font-size: var(--kl-fs-title-fluid);
  color: var(--kl-ink);
  margin: 0;
  letter-spacing: var(--kl-ls-tight);
}
.kl-block-title--light {
  color: #ffffff;
}
.kl-block-accent {
  display: block;
  width: 64px;
  height: 5px;
  margin: 16px auto 0;
  border-radius: var(--kl-radius-pill);
  background: linear-gradient(90deg, var(--kl-blue) 0%, var(--kl-teal) 100%);
}
.kl-block-accent--light {
  background: rgba(255, 255, 255, 0.9);
}

/* Funcionalidades */
.kl-features {
  padding: 80px 0;
}
.kl-features__shell {
  max-width: 1180px;
  margin: 0 auto;
  padding: 0 32px;
}
.kl-features__grid {
  margin-top: 48px;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 28px;
}
.kl-feature-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 18px;
  background: var(--kl-card);
  border: 1px solid var(--kl-border);
  border-radius: 18px;
  padding: 32px 28px;
  box-shadow: var(--kl-shadow);
  transition: transform 0.35s ease, box-shadow 0.35s ease,
    border-color 0.35s ease;
}
.kl-feature-card:hover {
  transform: translateY(-6px);
  border-color: var(--kl-blue);
  box-shadow: var(--kl-shadow-hover);
}
.kl-feature-card__icon {
  width: 64px;
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 16px;
  background: linear-gradient(
    135deg,
    rgba(0, 110, 200, 0.12),
    rgba(1, 173, 183, 0.12)
  );
}
.kl-feature-card__glyph {
  display: block;
  width: 36px;
  height: 36px;
  background-color: #01adb7;
  -webkit-mask-repeat: no-repeat;
  mask-repeat: no-repeat;
  -webkit-mask-position: center;
  mask-position: center;
  -webkit-mask-size: contain;
  mask-size: contain;
}
.kl-feature-card__text {
  margin: 0;
  font-size: var(--kl-fs-body);
  line-height: 1.6;
  color: var(--kl-text);
}
/* Beneficios */
.kl-benefits {
  padding: 90px 0;
  background: linear-gradient(
    135deg,
    var(--kl-blue-dark) 0%,
    var(--kl-blue) 55%,
    var(--kl-teal) 130%
  );
}
.kl-benefits__shell {
  max-width: 1180px;
  margin: 0 auto;
  padding: 0 32px;
}
.kl-benefits__carousel {
  margin-top: 48px;
}
.kl-benefits__page {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 24px;
  padding: 6px 56px;
}
/* Flechas */
.kl-benefits__carousel ::v-deep .carousel-control-prev,
.kl-benefits__carousel ::v-deep .carousel-control-next {
  width: 48px;
  opacity: 1;
}
.kl-benefits__carousel ::v-deep .carousel-control-prev-icon,
.kl-benefits__carousel ::v-deep .carousel-control-next-icon {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.2);
  background-size: 45% 45%;
  transition: background-color 0.25s ease;
}
.kl-benefits__carousel
  ::v-deep
  .carousel-control-prev:hover
  .carousel-control-prev-icon,
.kl-benefits__carousel
  ::v-deep
  .carousel-control-next:hover
  .carousel-control-next-icon {
  background-color: rgba(255, 255, 255, 0.45);
}
/* Indicadores */
.kl-benefits__carousel ::v-deep .carousel-indicators {
  margin-bottom: -8px;
}
.kl-benefits__carousel ::v-deep .carousel-indicators li {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  border: none;
  background-color: rgba(255, 255, 255, 0.4);
  transition: transform 0.25s ease, background-color 0.25s ease;
}
.kl-benefits__carousel ::v-deep .carousel-indicators li.active {
  background-color: #ffffff;
  transform: scale(1.25);
}
.kl-benefit-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 14px;
  background: #ffffff;
  border-radius: 18px;
  padding: 30px;
  height: 280px;
  margin-bottom: 1em;
  box-shadow: 0 14px 34px rgba(16, 38, 73, 0.18);
  transition: transform 0.35s ease, box-shadow 0.35s ease;
}
.kl-benefit-card:hover {
  transform: translateY(-6px);
  box-shadow: 0 22px 48px rgba(0, 0, 0, 0.28);
}
.kl-benefit-card__icon {
  width: 56px;
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 14px;
  background: linear-gradient(
    135deg,
    rgba(0, 110, 200, 0.12),
    rgba(1, 173, 183, 0.12)
  );
}
.kl-benefit-card__icon img {
  width: 32px;
  height: 32px;
  object-fit: contain;
}
.kl-benefit-card__title {
  margin: 0;
  font-weight: var(--kl-fw-bold);
  font-size: var(--kl-fs-title-sm);
  color: var(--kl-blue-dark);
  line-height: 1.3;
}
.kl-benefit-card__desc {
  margin: 0;
  font-size: var(--kl-fs-body);
  line-height: 1.65;
  color: var(--kl-text);
  text-align: justify;
}
/* Responsive grillas */
@media (max-width: 992px) {
  .kl-features__grid {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media (max-width: 768px) {
  .kl-features,
  .kl-benefits {
    padding: 60px 0;
  }
  .kl-features__shell,
  .kl-benefits__shell {
    padding: 0 20px;
  }
  .kl-features__grid {
    grid-template-columns: 1fr;
  }
  .kl-benefits__page {
    grid-template-columns: 1fr;
    padding: 6px 40px;
  }
  .kl-benefit-card {
    height: 380px;
  }
}
@media (max-width: 1500px) {
  .font-header {
    font-size: 44px;
  }
  .font-description {
    font-size: 22px;
  }
  #carousel-1 >>> .carousel-control-prev {
    left: 8% !important;
  }
  #carousel-1 >>> .carousel-control-next {
    right: 8% !important;
  }
  .home-carousel-3-background {
    height: 470px;
  }
  .carousel-3-container {
    height: 470px;
  }
}
@media (max-width: 1000px) {
  .header-container {
    display: none;
  }
  .header-banner-container {
    display: flex;
    background: url(../../assets/new-page/2_banner_principal_home.svg) no-repeat;
  }
  #carousel-1 >>> .carousel-control-prev {
    left: 0% !important;
  }
  #carousel-1 >>> .carousel-control-next {
    right: 0% !important;
  }
  .header-banner-container {
    flex-direction: column-reverse;
    flex-wrap: nowrap;
    height: auto;
  }
  .header-banner-right {
    display: none;
  }
  .header-banner-card {
    margin-top: 1em;
    width: 100%;
  }
  .carousel-2-container {
    flex-direction: column;
    flex-wrap: nowrap;
    height: auto;
  }
  .carousel-2-style {
    width: 95%;
  }
  .carousel-2-sub-container-left {
    width: 100%;
    margin-bottom: 4rem;
  }
  .carousel-2-sub-container-right {
    width: 100%;
    flex-wrap: wrap;
  }
  .carousel-3-card-container {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: space-around;
  }
  .carousel-3-card {
    margin-right: 10px;
  }
  .carousel-2-card {
    margin-bottom: 3em;
  }
  .container-saas {
    width: 100%;
  }
  .borchure-saas {
    margin: 2%;
    height: auto;
  }
}
@media (max-width: 770px) {
  .home-carousel-3-background {
    height: 730px;
  }
  .carousel-3-card {
    display: block;
    width: 100%;
    width: 90%;
  }
  .carousel-3-container {
    height: 730px;
  }
  .carousel-3-card-container {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-around;
  }
}
@media (max-width: 700px) {
  .home-carousel-3-background {
    height: 700px;
  }
  .carousel-3-container {
    height: 700px;
  }
  .carousel-2-sub-container-right {
    width: 100%;
    flex-wrap: wrap;
  }
  @media (max-width: 600px) {
    .font-header {
      text-align: center;
    }
  }
  @media (max-width: 485px) {
    .header-banner-container {
      height: auto;
      background-size: cover;
    }
    .carousel-2-card {
      margin-bottom: 3em;
    }
  }
}

/* ============================================================
   Descarga de documentos (mismo estilo que Brochure)
   ============================================================ */
.kl-docs {
  padding: 80px 0;
  background: var(--kl-bg);
}
.kl-docs__shell {
  max-width: 1180px;
  margin: 0 auto;
  padding: 0 32px;
}
.kl-docs__grid {
  margin-top: 48px;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 36px;
}

.kl-doc-card {
  position: relative;
  display: flex;
  flex-direction: column;
  background: var(--kl-card);
  border: 1px solid var(--kl-border);
  border-radius: 22px;
  padding: 40px 38px 34px;
  box-shadow: var(--kl-shadow);
  transition: transform 0.35s ease, box-shadow 0.35s ease;
  overflow: hidden;
}
.kl-doc-card::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 6px;
  background: linear-gradient(90deg, var(--kl-blue) 0%, var(--kl-teal) 100%);
}
.kl-doc-card:hover {
  transform: translateY(-8px);
  box-shadow: var(--kl-shadow-hover);
}
.kl-doc-card__top {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 18px;
}
.kl-doc-card__badge {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 52px;
  height: 52px;
  border-radius: 14px;
  background: linear-gradient(135deg, var(--kl-blue) 0%, var(--kl-teal) 100%);
  color: #ffffff;
  font-weight: var(--kl-fw-bold);
  font-size: var(--kl-fs-small);
  letter-spacing: 0.5px;
  box-shadow: 0 8px 18px rgba(0, 110, 200, 0.28);
}
.kl-doc-card__title {
  font-weight: var(--kl-fw-bold);
  font-size: var(--kl-fs-title-md);
  line-height: 1.25;
  margin: 0;
  background: linear-gradient(
    135deg,
    var(--kl-blue-dark) 0%,
    var(--kl-teal) 100%
  );
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  letter-spacing: -0.01em;
}
.kl-doc-card__desc {
  flex: 1;
  font-size: var(--kl-fs-body-lg);
  line-height: var(--kl-lh-relaxed);
  color: var(--kl-text);
  margin: 0 0 28px;
  text-align: justify;
}
.kl-doc-card__btn {
  align-self: center;
  display: inline-flex;
  align-items: center;
  padding: 0 20px 0 20px;
  height: 54px;
  border: none;
  border-radius: var(--kl-radius-pill);
  background: linear-gradient(135deg, var(--kl-blue) 0%, var(--kl-teal) 100%);
  color: #ffffff;
  font-weight: var(--kl-fw-semibold);
  font-size: var(--kl-fs-caption);
  letter-spacing: 0.1em;
  text-transform: uppercase;
  box-shadow: 0 10px 24px rgba(0, 110, 200, 0.28);
  transition: transform 0.25s ease, box-shadow 0.25s ease, filter 0.25s ease;
}
.kl-doc-card__btn:hover {
  color: #ffffff;
  transform: translateY(-2px);
  filter: brightness(1.05);
  box-shadow: 0 14px 30px rgba(0, 110, 200, 0.35);
}
.kl-doc-card__btn img {
  width: 38px;
  height: 38px;
  padding: 8px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.18);
}

@media (max-width: 900px) {
  .kl-docs__grid {
    grid-template-columns: 1fr;
    gap: 24px;
  }
  .kl-docs__shell {
    padding: 0 22px;
  }
}

/* Seccion IA Styles */
.ia-section-container {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 60px 20px;
}

.ia-content {
  background: #ffffff;
  border-radius: 20px;
  padding: 60px 70px;
  border: 1px solid rgba(0, 110, 200, 0.08);
  position: relative;
  overflow: hidden;
}

.ia-content::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, #006ec8 0%, #01adb7 100%);
}

.ia-header {
  display: flex;
  align-items: center;
  gap: 30px;
  margin-bottom: 45px;
  padding-bottom: 30px;
  border-bottom: 2px solid rgba(0, 110, 200, 0.1);
}

.ia-icon-wrapper {
  position: relative;
  flex-shrink: 0;
}

.ia-icon-wrapper::before {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 90px;
  height: 90px;
  background-color: var(--kl-fourth-hover-color) !important;
  border-radius: 50%;
  z-index: 0;
}

.ia-icon {
  width: 70px;
  height: 70px;
  position: relative;
  z-index: 1;
  filter: drop-shadow(0 4px 12px rgba(0, 110, 200, 0.2));
}

.ia-header-text {
  flex: 1;
}

.ia-title {
  font-weight: var(--kl-fw-bold);
  font-size: var(--kl-fs-title-lg);
  line-height: var(--kl-lh-tight);
  background: linear-gradient(
    135deg,
    var(--kl-color-primary) 0%,
    var(--kl-color-secondary) 100%
  );
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  margin: 0 0 12px 0;
  letter-spacing: -0.8px;
}

.ia-subtitle {
  font-weight: var(--kl-fw-medium);
  font-size: var(--kl-fs-body-lg);
  line-height: var(--kl-lh-base);
  color: var(--kl-text-body);
  margin: 0;
}

.ia-body {
  margin-bottom: 45px;
}

.ia-paragraph {
  font-size: var(--kl-fs-body-lg);
  line-height: 1.9;
  color: var(--kl-text-body);
  margin-bottom: 24px;
  text-align: justify;
}

.ia-highlight {
  background: linear-gradient(
    90deg,
    rgba(0, 110, 200, 0.05) 0%,
    rgba(1, 173, 183, 0.05) 100%
  );
  padding: 24px 28px;
  border-radius: var(--kl-radius-lg);
  border-left: 4px solid var(--kl-color-primary);
  font-weight: var(--kl-fw-medium);
  color: var(--kl-text-heading);
}

.ia-footer-section {
  background: linear-gradient(
    135deg,
    rgba(0, 110, 200, 0.03) 0%,
    rgba(1, 173, 183, 0.03) 100%
  );
  padding: 35px 40px;
  border-radius: 16px;
  border: 1px solid rgba(0, 110, 200, 0.1);
}

.ia-footer-badge {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 20px;
}

.ia-badge-icon {
  font-size: 20px;
  color: var(--kl-color-primary);
  font-weight: var(--kl-fw-bold);
}

.ia-footer-title {
  font-weight: var(--kl-fw-bold);
  font-size: var(--kl-fs-title-sm);
  background: linear-gradient(
    90deg,
    var(--kl-color-primary) 0%,
    var(--kl-color-secondary) 100%
  );
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  margin: 0;
  line-height: 1.3;
}

.ia-footer-text {
  font-size: var(--kl-fs-body-lg);
  line-height: var(--kl-lh-relaxed);
  color: var(--kl-text-body);
  margin: 0;
  text-align: justify;
}
/* Diagrama central: KL Innovation + KL Assessment */
.kl-diagram {
  position: relative;
  display: grid;
  grid-template-columns: 1fr 1fr;
  max-width: 1000px;
  margin: 24px auto 8px;
  border-radius: 22px;
  overflow: hidden;
  box-shadow: 0 22px 50px rgba(16, 38, 73, 0.18);
}
.kl-diagram__panel {
  position: relative;
  min-height: 230px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 6px;
  padding: 40px 60px;
  color: #ffffff;
  overflow: hidden;
}
.kl-diagram__panel--innovation {
  background: linear-gradient(90deg, #0061b3 0%, #0091b9 100%);
  align-items: flex-start;
  text-align: left;
  padding-right: 90px;
}
.kl-diagram__panel--assessment {
  background: linear-gradient(90deg, #0091b9 0%, #06c1cb 100%);
  align-items: flex-end;
  text-align: right;
  padding-left: 90px;
}
.kl-diagram__panel::after {
  content: "";
  position: absolute;
  width: 260px;
  height: 260px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.08);
}
.kl-diagram__panel--innovation::after {
  top: -90px;
  left: -60px;
}
.kl-diagram__panel--assessment::after {
  bottom: -90px;
  right: -60px;
}
.kl-diagram__tag {
  font-size: 18px;
  font-weight: 600;
  letter-spacing: 6px;
  opacity: 0.85;
}
.kl-diagram__name {
  font-size: clamp(28px, 4vw, 44px);
  font-weight: 800;
  letter-spacing: -0.01em;
  line-height: 1;
}
.kl-diagram__hub {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 112px;
  height: 112px;
  border-radius: 50%;
  background: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.2);
  z-index: 2;
}
.kl-diagram__hub img {
  width: 66px;
  height: 66px;
  object-fit: contain;
}
@media (max-width: 768px) {
  .kl-diagram {
    grid-template-columns: 1fr;
  }
  .kl-diagram__panel {
    min-height: 160px;
  }
  .kl-diagram__panel--innovation {
    align-items: center;
    text-align: center;
    padding: 34px 28px 56px;
  }
  .kl-diagram__panel--assessment {
    align-items: center;
    text-align: center;
    padding: 56px 28px 34px;
  }
}
/* Mapa de ubicación */
.home-map-wrapper {
  background: #ffffff;
  padding: 70px 32px;
}
.home-map {
  max-width: 100%;
  margin: 0 auto;
  height: 420px;
  border-radius: 22px;
  overflow: hidden;
  border: 1px solid var(--kl-border);
  box-shadow: var(--kl-shadow);
}
.home-map iframe {
  display: block;
  width: 100%;
  height: 100%;
}
@media (max-width: 768px) {
  .home-map-wrapper {
    padding: 48px 18px;
  }
  .home-map {
    height: 320px;
  }
}
/* Estilos para el diagrama con anotaciones */
.diagram-section {
  width: 90%;
  max-width: 1400px;
  margin: 40px auto;
}

/* Responsive */
@media (max-width: 1200px) {
  .diagram-section {
    width: 95%;
  }
}

@media (max-width: 768px) {
  .diagram-section {
    padding: 0;
  }
}

@media (max-width: 768px) {
  .ia-section-container {
    padding: 60px 15px;
  }

  .ia-content {
    padding: 35px 25px;
    border-radius: 16px;
  }

  .ia-header {
    flex-direction: column;
    align-items: center;
    text-align: center;
    gap: 20px;
    margin-bottom: 35px;
  }

  .ia-icon-wrapper::before {
    width: 75px;
    height: 75px;
  }

  .ia-icon {
    width: 60px;
    height: 60px;
  }

  .ia-title {
    font-size: 26px;
  }

  .ia-subtitle {
    font-size: 16px;
  }

  .ia-paragraph {
    font-size: 16px;
    text-align: left;
  }

  .ia-highlight {
    padding: 20px;
  }

  .ia-footer-section {
    padding: 25px 20px;
  }

  .ia-footer-badge {
    flex-direction: column;
    align-items: center;
    text-align: center;
    gap: 8px;
  }

  .ia-footer-title {
    font-size: 16px;
  }

  .ia-footer-text {
    font-size: 16px;
    text-align: left;
  }
}

/* ============================================================
   Vistazo a la plataforma (carousel de screenshots)
   ============================================================ */
.kl-shots {
  background: var(--kl-bg);
}
.kl-shots__shell {
  max-width: 1180px;
  margin: 0 auto;
  padding: 0 32px;
}
.kl-shots__subtitle {
  max-width: 720px;
  margin: 18px auto 0;
  text-align: center;
  font-size: var(--kl-fs-body-lg);
  line-height: var(--kl-lh-base);
  color: var(--kl-text);
}
.kl-shots__carousel {
  margin-top: 40px;
  /* Reserva espacio al fondo para los indicadores, para que queden DEBAJO del
     caption y no se solapen con el título de la captura. */
  padding-bottom: 15px;
}
.kl-shots__carousel ::v-deep .carousel-indicators {
  bottom: 0;
  margin-bottom: 0;
}
.kl-shot {
  margin: 0;
  padding: 0 56px 8px;
}
.kl-shot__frame {
  max-width: 900px;
  margin: 0 auto;
  background: #ffffff;
  border: 1px solid var(--kl-border);
  border-radius: 16px;
  overflow: hidden;
}
.kl-shot__bar {
  display: flex;
  align-items: center;
  gap: 7px;
  padding: 12px 16px;
  background: linear-gradient(
    90deg,
    rgba(0, 110, 200, 0.06),
    rgba(1, 173, 183, 0.06)
  );
  border-bottom: 1px solid var(--kl-border);
}
.kl-shot__dot {
  width: 11px;
  height: 11px;
  border-radius: 50%;
  background: rgba(16, 38, 73, 0.18);
}
.kl-shot__dot:nth-child(1) {
  background: var(--kl-blue);
}
.kl-shot__dot:nth-child(2) {
  background: var(--kl-teal);
}
.kl-shot__img {
  display: block;
  width: 100%;
  /* Altura fija para todas las capturas: así el carousel no "salta" cuando una
     imagen es más alta que otra. object-fit: contain muestra la captura
     COMPLETA (sin recortar ancho/alto); si sobra espacio, deja bandas. */
  height: 460px;
  object-fit: contain;
  object-position: center;
  background: var(--kl-surface-muted);
}
/* Caption dentro del marco (barra inferior), igual que el hero */
.kl-shot__caption {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 12px 16px;
  border-top: 1px solid var(--kl-border);
  font-weight: var(--kl-fw-semibold);
  font-size: var(--kl-fs-small);
  color: var(--kl-ink);
  text-align: left;
}
.kl-shot__caption-icon {
  flex-shrink: 0;
  color: var(--kl-color-primary);
}
/* Controles: fondo claro → flechas/indicadores en azul de marca */
.kl-shots__carousel ::v-deep .carousel-control-prev,
.kl-shots__carousel ::v-deep .carousel-control-next {
  width: 48px;
  opacity: 1;
}
.kl-shots__carousel ::v-deep .carousel-control-prev-icon,
.kl-shots__carousel ::v-deep .carousel-control-next-icon {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: var(--kl-color-primary);
  background-size: 45% 45%;
  transition: filter 0.25s ease;
}
.kl-shots__carousel
  ::v-deep
  .carousel-control-prev:hover
  .carousel-control-prev-icon,
.kl-shots__carousel
  ::v-deep
  .carousel-control-next:hover
  .carousel-control-next-icon {
  filter: brightness(1.1);
}
.kl-shots__carousel ::v-deep .carousel-indicators li {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  border: none;
  background-color: rgba(0, 110, 200, 0.3);
}
.kl-shots__carousel ::v-deep .carousel-indicators li.active {
  background-color: var(--kl-color-primary);
  transform: scale(1.25);
}
@media (max-width: 768px) {
  .kl-shots {
    padding: 60px 0;
  }
  .kl-shots__shell {
    padding: 0 20px;
  }
  .kl-shot {
    padding: 0 34px;
  }
  .kl-shot__img {
    height: 300px;
  }
}
</style>